module.exports = __webpack_public_path__ + "static/img/KJY_nav3.5b353f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/KJY_nav3.png
// module id = Acac
// module chunks = 1